var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{key:_vm.$route.fullPath}),(_vm.$route.name == 'assignments')?[_c('v-container',{staticClass:"container--narrow"},[(_vm.items.length)?_c('FilterableList',{attrs:{"items":_vm.items,"enable-search":false},on:{"itemClick":_vm.itemClick}}):_vm._e()],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }